import { motion } from 'framer-motion'

export default function Card({
  children,
  className = '',
  hover = true,
  gradient = false,
  onClick,
}) {
  return (
    <motion.div
      onClick={onClick}
      whileHover={hover ? { y: -6, boxShadow: '0 20px 50px rgba(26,10,46,0.18)' } : undefined}
      transition={{ type: 'spring', stiffness: 300, damping: 22 }}
      className={[
        'rounded-3xl shadow-card transition-shadow duration-300',
        gradient ? 'bg-gradient-card' : 'bg-white',
        onClick ? 'cursor-pointer' : '',
        className,
      ].join(' ')}
    >
      {children}
    </motion.div>
  )
}
